'use client';

import { Heart } from 'lucide-react';

import { formatCount } from '../../../functions/format-post-date';

interface Props {
  liked: boolean;
  likeCount: number;
  onToggle: () => void;
}

/**
 * Presentational like control — the heart + count. All state (optimistic toggle,
 * the anonymous → `/login` bounce, fetched counts) lives in {@link usePostStats},
 * owned by {@link PostFooter}; this just renders and forwards the click.
 */
export function PostLikeButton({ liked, likeCount, onToggle }: Props) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="flex items-center gap-1.5 text-[12px] opacity-80 transition hover:opacity-100"
      aria-label={liked ? 'Unlike' : 'Like'}
    >
      <Heart
        className="h-[18px] w-[18px]"
        style={
          liked
            ? { fill: 'hsl(var(--danger))', color: 'hsl(var(--danger))' }
            : undefined
        }
        aria-hidden
      />
      <span>{formatCount(likeCount)}</span>
    </button>
  );
}
